var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.attrs
        ? _c("p", { staticClass: "d-flex align-items-center" }, [
            _c(
              "span",
              {
                staticClass:
                  "product-view__package__title font__family--gotham font__weight--medium font__color--gray",
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      id: "SVGDoc",
                      width: "24",
                      height: "24",
                      xmlns: "http://www.w3.org/2000/svg",
                      version: "1.1",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xmlns:avocode": "https://avocode.com/",
                      viewBox: "0 0 24 24",
                    },
                  },
                  [
                    _c("g", [
                      _c("g", [
                        _c("title", [_vm._v("Stroke 429")]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M1,6h22",
                            "fill-opacity": "0",
                            fill: "#ffffff",
                            "stroke-dashoffset": "0",
                            "stroke-linejoin": "round",
                            "stroke-linecap": "round",
                            "stroke-opacity": "1",
                            stroke: "#9da3a6",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.399999976158142",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("title", [_vm._v("Stroke 431")]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M15,13v0h-6v0v-7v0l2,-5v0h2v0l2,5v0z",
                            "fill-opacity": "0",
                            fill: "#ffffff",
                            "stroke-dashoffset": "0",
                            "stroke-linejoin": "round",
                            "stroke-linecap": "round",
                            "stroke-opacity": "1",
                            stroke: "#9da3a6",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.399999976158142",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("title", [_vm._v("Stroke 430")]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M23,6v0l-6,-5v0h-10v0l-6,5v0v17v0h22v0z",
                            "fill-opacity": "0",
                            fill: "#ffffff",
                            "stroke-dashoffset": "0",
                            "stroke-linejoin": "round",
                            "stroke-linecap": "round",
                            "stroke-opacity": "1",
                            stroke: "#9da3a6",
                            "stroke-miterlimit": "20",
                            "stroke-width": "1.399999976158142",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("title", [_vm._v("Group 6")]),
                        _vm._v(" "),
                        _c("g", [
                          _c("title", [_vm._v("Stroke 430")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M23,6v0l-6,-5v0h-10v0l-6,5v0v17v0h22v0z",
                              "fill-opacity": "0",
                              fill: "#ffffff",
                              "stroke-dashoffset": "0",
                              "stroke-linejoin": "round",
                              "stroke-linecap": "round",
                              "stroke-opacity": "1",
                              stroke: "#9da3a6",
                              "stroke-miterlimit": "20",
                              "stroke-width": "1.399999976158142",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("g", [
                          _c("title", [_vm._v("Stroke 431")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M15,13v0h-6v0v-7v0l2,-5v0h2v0l2,5v0z",
                              "fill-opacity": "0",
                              fill: "#ffffff",
                              "stroke-dashoffset": "0",
                              "stroke-linejoin": "round",
                              "stroke-linecap": "round",
                              "stroke-opacity": "1",
                              stroke: "#9da3a6",
                              "stroke-miterlimit": "20",
                              "stroke-width": "1.399999976158142",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("g", [
                          _c("title", [_vm._v("Stroke 429")]),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M1,6h22",
                              "fill-opacity": "0",
                              fill: "#ffffff",
                              "stroke-dashoffset": "0",
                              "stroke-linejoin": "round",
                              "stroke-linecap": "round",
                              "stroke-opacity": "1",
                              stroke: "#9da3a6",
                              "stroke-miterlimit": "20",
                              "stroke-width": "1.399999976158142",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm._t("title"),
                _vm._v(":\n                    "),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.attrs, function (item, index) {
        return _vm.attrs
          ? _c("div", { staticClass: "radio-el" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.picked_num,
                    expression: "picked_num",
                  },
                ],
                staticClass: "radio-el__input",
                attrs: { name: "attrs", type: "radio", id: "choice" + index },
                domProps: {
                  value: index,
                  checked: index === 0,
                  checked: _vm._q(_vm.picked_num, index),
                },
                on: {
                  change: function ($event) {
                    _vm.picked_num = index
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "radio-el__label d-flex justify-content-between align-items-center",
                  attrs: { for: "choice" + index },
                },
                [
                  _c("span", { staticClass: "d-flex align-items-center" }, [
                    _c("span", { staticClass: "checkmark mr-4" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "radio-el__label__text font__family--gotham font__weight--medium font__color--gray",
                      },
                      [
                        _vm._v(
                          _vm._s(item.product_title) +
                            " " +
                            _vm._s(item.description)
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "price radio-el__label__text font__family--gotham font__weight--medium font__color--gray",
                    },
                    [_vm._v(_vm._s(item.price) + " " + _vm._s(item.currency))]
                  ),
                ]
              ),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.picked_num != null || _vm.product,
              expression: "picked_num != null || product",
            },
          ],
          staticClass: "box box__classic py-4 add-to-cart animate__animated",
          class: { animate__fadeIn: _vm.picked_num != null },
        },
        [
          _c("div", { staticClass: "d-flex justify-content-between mb-4" }, [
            _c("div", {}, [
              _c(
                "p",
                {
                  staticClass:
                    "add-to-cart__text font__family--gotham font__weight--medium font__color--gray-light mb-0 pr-2",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("quantity", "cart")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "counter-box" }, [
                _c("p", { staticClass: "counter-box__arrows mb-0" }, [
                  _c("span", {
                    staticClass:
                      "plus counter-box__arrow counter-box__arrow__next",
                    on: { click: _vm.getMoreQuantity },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass:
                      "minus counter-box__arrow counter-box__arrow__prev",
                    on: { click: _vm.getLessQuantity },
                  }),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.counts_product,
                      expression: "counts_product",
                    },
                  ],
                  staticClass: "counter-box__input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.counts_product },
                  on: {
                    blur: _vm.update_count,
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.counts_product = $event.target.value
                      },
                      _vm.update_count,
                    ],
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-right" }, [
              _c(
                "p",
                {
                  staticClass:
                    "add-to-cart__text font__family--gotham font__weight--medium font__color--gray-light mb-0 pr-2",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("amount", "products_list")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.picked_num != null || _vm.product
                ? _c(
                    "p",
                    {
                      staticClass:
                        "add-to-cart__price font__family--gotham font__weight--medium font__color--gray mb-0",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.picked_price) +
                          " " +
                          _vm._s(_vm.currency)
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          (_vm.picked_num != null && _vm.is_in_stock) ||
          (_vm.product && _vm.is_in_stock)
            ? _c(
                "button",
                {
                  staticClass:
                    "skew cookie-bar__accept button button__new button__new--blue w-100",
                  class: { "button__bg--blue btn-loader": _vm.show_loader },
                  on: { click: _vm.addToCart },
                },
                [_c("span", [_vm._t("btn")], 2)]
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.picked_num != null && !_vm.is_in_stock) ||
          (_vm.product && !_vm.is_in_stock)
            ? _c("div", {}, [
                _c(
                  "button",
                  {
                    staticClass:
                      "skew cookie-bar__accept button button--disable button__new button__new--blue w-100",
                  },
                  [_c("span", [_vm._t("btn_out")], 2)]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-4 my-3 text-center" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "font__family--gotham font__weight--light font__color--blue-light links links__normal",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.waitListPopup.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._t("waitlist")],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      (_vm.picked_num != null && !_vm.is_in_stock) ||
      (_vm.product && !_vm.is_in_stock)
        ? _c("popup-waitlist")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }